import $2 from 'jquery';
import 'select2';
//librerías para funcionalidad de UI
var ui = function(){
	//funciones de inicialización
	var funcInit = [];
	//determina si se ha llamado ya al init inicial
	var initInicioLanzado = false;

	/**
	 * Incorpora la función pasada a la inicialización del documento para los elementos del selector pasado (se llamará una vez por elemento)
	 * @param string jqSelector Selector jquery del elemento
	 * @param function f Función
	 */
	function ready(jqSelector,f){
		if(jqSelector.indexOf(",")==-1){
			var func = {"funcion":f,"jqSelector":jqSelector};
			funcInit.push(func);
			//si ya se ha llamado a la inicialización inicial, llamamos a init sólo con la funcion pasada para el body
			if(initInicioLanzado)
				initBase(null,func);
		}else{
			var jqSels = jqSelector.split(",");
			for(var i=0;i<jqSels.length;i++)
				ready(jqSels[i],f);
		}
	}

	/**
	 * Incorpora la función pasada a la inicialización general del body exclusivamente
	 * @param function f Función
	 */
	function readyBody(f){
		ready("body",f);
	}

	/**
	 * Incorpora la función pasada a la inicialización de selector
	 * @param string jqSelectorBloque Selector jquery para filtrar el bloque de evaluador
	 * @param function f Función
	 */
	function readySelectorBloque(jqSelectorBloque,f){
		if(jqSelectorBloque){
			var jqSels = jqSelectorBloque.split(",");
			for(var i=0;i<jqSels.length;i++)
				ready(".selectorBloque"+jqSels[i],f);
		}else
			ready(".selectorBloque",f);
	}

	/**
	 * Incorpora la función pasada a la inicialización de selector
	 * @param string jqSelectorBloque Selector jquery para filtrar el bloque de evaluador
	 * @param function f Función
	 */
	function readySelectorInfo(jqSelectorBloque,f){
		if(jqSelectorBloque){
			var jqSels = jqSelectorBloque.split(",");
			for(var i=0;i<jqSels.length;i++)
				ready(".selectorBloque"+jqSels[i]+" .selectorInfo",f);
		}else
			ready(".selectorBloque .selectorInfo",f);
	}

	/**
	 * Incorpora la función pasada a la inicialización de página de selector (navegación)
	 * @param string jqSelector Selector jquery para localizar la página (.paginaSelectorXXX)
	 * @param function f Función
	 */
	function readySelectorPagina(jqSelectorPagina,f){
		if(jqSelectorPagina){
			var jqSels = jqSelectorPagina.split(",");
			for(var i=0;i<jqSels.length;i++)
				ready(".paginaSelector"+$.trim(jqSels[i]),f);
		}else
			ready(".paginaSelector",f);
	}

	/**
	 * Función para inicializar el DOM bajo un nodo jQuery
	 * @param jQuery jq Objeto jQuery que se inicializará (junto con sus hijos)
	 * @param function funcEjec Funcion a ejecutar si no se quiere usar la lista global (opcional)
	 */
	function initBase(jq,funcEjec){
		if(jq && jq.size()==0)
			return;

		var funcs = null;
		if(funcEjec)
			funcs = [funcEjec];
		else
			funcs = funcInit;

		if(!jq)
			jq = $("body");
		var esBody = jq.is("body");
		var selsVacios = []; //lista de selectores sin resultados
		var cItems = {};
		for(var i=0;i<funcs.length;i++){
			var func = funcs[i].funcion;
			var jqSel = funcs[i].jqSelector;
			if(func){
				if(cItems[jqSel]){ //teníamos los items precacheados
					var items = cItems[jqSel];
					//llamamos a la función por cada item
					for(var j=0;j<items.length;j++)
						func(items[j]);

				}else{ //items sin precachear
					//miramos si el comienzo de este selector ya lo hemos localizado en otro más genérico y no tiene items
					var sinItems = false;
					for(var j=0;j<selsVacios.length;j++){
						var selV = selsVacios[j];
						if(jqSel.length>selV.length && jqSel.indexOf(selV)===0 && "abcdefghijklmnopqrstuvwxyz-_".indexOf(jqSel.charAt(selV.length).toLowerCase())==-1){
							sinItems = true;
							break;
						}
					}
					if(sinItems)
						continue;
					var jqF = null;
					if(jq.is(jqSel))
						jqF = jq.filter(jqSel);
					else
						jqF = jq.find(jqSel);

					var items = [];
					if(jqF.size()>0){ //is o find encontrado
						jqF.each(
							function(){
								var item = $(this);
								items.push(item);
								func(item);
							}
						);
						if(items.length==0) //además de la caché, guardamos los selectores que no tienen resultados (buscando luego prefijos iremos más rápido). Esto solo aplica a find, ya que "is" siempre tendrá al menos un item
							selsVacios.push(jqSel);
					}else if(!esBody){ //búsqueda global (si no es body el item sobre el que buscar)
						var jqF = $(jqSel);
						jqF.each(
							function(){
								if(jq.find(this).size()>0){ //chequeamos que el item esté contenido en el nodo origen
									var item = $(this);
									func(item);
									items.push(item);
								}
							}
						);
					}
					//guardamos caché
					cItems[jqSel] = items;
				}
			}
		}
	}

	/**
	 * Función para inicializar el DOM bajo un nodo jQuery
	 * @param jQuery jq Objeto jQuery que se inicializará (junto con sus hijos)
	 */
	function init(jq){
		initBase(jq);
	}

	/**
	 * Inicializa el jQuery UI
	 * @param function funcionOk Función a ejecutar una vez cargado
	 */
	function initJQueryUI(funcionOk,version){
		if(!version)
			version = "1.11.2";
		if(!nbf.objetoDefinido("$.ui")){
			nbf.cargarJs(
				"/nbf/js/nbf/jquery/jquery-ui-"+version+".custom.min.js",
				function(){
					if(funcionOk)
						funcionOk();
				}
			);
		}else{
			if(funcionOk)
				funcionOk();
		}
	}

	function actualizarContadoresPopFrames(){
		var pop = $(".popFrame");
		var n = pop.filter(":visible").size();
		if(n>0)
			$("body").addClass("backpopFrame");
		else
			$("body").removeClass("backpopFrame");
		pop.each(
			function(){
				var p = $(this);
				p.removeClass("popFrameN"+p.data("popframe-nivel"));
				if(p.is(":visible")){
					p.data("popframe-nivel",n);
					p.addClass("popFrameN"+n);
					if(n>1)
						p.addClass("backpopFrame");
					else
						p.removeClass("backpopFrame");
					n--;
				}
			}
		);
	}

	/**
	 * Crea un popframe para contener popups y navegaciones de selectores
	 */
	function crearPopFrame(esSelector){
		var pop = $("<div />");
		pop.attr("id",nbf.generarIdAleatorio());
	    pop.addClass("popFrame");
	    if(esSelector)
	    	pop.addClass("popFrameSelector");
	    else
	    	pop.addClass("popFramePopup");
	    $("body").append(pop);
	    if(!esSelector)
	    	mostrarPopFrame(pop);
	    else //en selector lo ocultamos para que no se tenga en cuenta en los contadores de nivel
	    	pop.hide();
	    return pop;
	}

	/**
	 * Muestra un popframe y lo pone encima de la pila
	 */
	function mostrarPopFrame(jqPop){
		//lo volvemos a poner el último
		jqPop.nextAll(".popFrame:last").after(jqPop);
		if(!jqPop.is(":visible"))
			jqPop.show();
		actualizarContadoresPopFrames();
	}

	/**
	 * Oculta un popframe y activa el siguiente de la pila
	 */
	function ocultarPopFrame(jqPop){
		//primero lo ocultamos
		jqPop.hide();
		//lo ponemos el primero de la lista
		jqPop.prevAll(".popFrame:first").before(jqPop);
		//lo eliminamos
		jqPop.remove();
		actualizarContadoresPopFrames();
	}

	/**
	 * Añade la clase overscroll si el elemento se sale del scroll actual de página (por abajo o por la derecha)
	 * @param jq
	 */
	function checkOverscroll(jq,jqAddClass){
		if(!jqAddClass) //si no viene al que hay que añadirle el class ponemos este mismo
			jqAddClass = jq;
		var v = $(window);
		//debemos eliminar las clases para que se computen medidas correctamente
		jqAddClass.removeClass("overscrollH overscrollW");
		if(jq.offset().top+Math.max(jq.height(),100)>v.scrollTop()+v.height() && jq.offset().top-Math.max(jq.height(),100)>v.scrollTop())
			jqAddClass.addClass("overscrollH");
		else
			jqAddClass.removeClass("overscrollH");
		if(jq.offset().left+jq.width()>v.scrollLeft()+v.width())
			jqAddClass.addClass("overscrollW");
		else
			jqAddClass.removeClass("overscrollW");
	}

	/**
	 * Intercambia las clases del objeto (si no tiene ninguna pone clase1)
	 * @param jQuery jq Objeto
	 * @param string clase1 Clase1 a cambiar
	 * @param string clase2 Clase2 a cambiar
	 * @return jQuery Referencia al objeto
	 */
	function intercambiarClass(jq,clase1,clase2){
		if(jq.hasClass(clase1)){
			jq.removeClass(clase1);
			jq.addClass(clase2);
		}else{
			jq.removeClass(clase2);
			jq.addClass(clase1);
		}
		return jq;
	}

	/**
	 * Pone el class cuando se haga hover sobre el elemento
	 * @param jQuery jq Objeto
	 * @param string claseHover Clase a añadir cuando se haga hover
	 * @return jQuery Referencia al objeto
	 */
	function hoverClass(jq,claseHover){
		jq.hover(
			function(){
				$(this).addClass(claseHover);
			},
			function(){
				$(this).removeClass(claseHover);
			}
		);
		return jq;
	}

	/**
	 * Obtiene/establece el valor del atributo data con el nombre pasado
	 * @param {jQuery} jqElem Objeto jquery
	 * @param {string} nombre Nombre del atributo (cadena tras data-)
	 * @param {*=} valor Valor a asignar (opcional)
	 * @return {*} Objeto codificado en el parámetro
	 */
	function atrData(jq,nombre,valor){
		var c = "data-"+nombre;
		if(valor!==undefined)
			jq.attr(c,nbf.toJSON(valor));
		return nbf.parseJSON(jq.attr(c));
	}

	/**
	 * Obtiene/establece los valores del atributo data con el nombre pasado
	 * @param {jQuery} jqElem Objeto jquery
	 * @param {Object=} valores Valores a asignar (opcional)
	 * @return {Object} Objeto con propiedades de cada data
	 */
	function atrDatas(jq,valores){
		if(valores!==undefined){
			for(var i in valores)
				atrData(jq,i,valores[i]);
		}

		var obj = {};
		$.each(
			jq.get(0).attributes,
			function(){
				if(this.specified && this.name.indexOf("data-")===0){
					var p = this.name.substring(5);
					obj[p] = atrData(jq,p);
				}
			}
		);
		return obj;
	}

	//extendemos funcionalidad jquery
	jQuery.fn.extend(
		{
			"intercambiarClass":function(clase1,clase2){
				 return intercambiarClass(this,clase1,clase2);
			},
			"checkOverscroll":function(jqAddClass){
				return checkOverscroll(this,jqAddClass);
			},
			"hoverClass":function(claseHover){
				return hoverClass(this,claseHover);
			},
			"atrData":function(nombre,valor){
				return atrData(this,nombre,valor);
			},
			"atrDatas":function(valores){
				return atrDatas(this,valores);
			}
		}
	);

	$(document).ready(
		function(){
			if(FastClick)
				FastClick.attach(document.body);
			init();
			initInicioLanzado = true;
		}
	);

	$2(document).ready(
		function iniciarSelect2() {
			$2(".select2").select2();
		}
	);

	return {
		"ready":ready,
		"readyBody":readyBody,
		"readySelectorBloque":readySelectorBloque,
		"readySelectorInfo":readySelectorInfo,
		"readySelectorPagina":readySelectorPagina,
		"init":init,
		"initJQueryUI":initJQueryUI,
		"crearPopFrame":crearPopFrame,
		"mostrarPopFrame":mostrarPopFrame,
		"ocultarPopFrame":ocultarPopFrame,
		"checkOverscroll":checkOverscroll,
		"intercambiarClass":intercambiarClass,
		"hoverClass":hoverClass,
		"atrData":atrData,
		"atrDatas":atrDatas
	};
}();

window.ui = ui;// TODO: Intentar cambiar la filosofía a módulos reales
